<template>
  <div class="recharge_audit">
    <div class="caozuo"></div>
    <div class="conent">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="未审核" name="0"></el-tab-pane>
        <el-tab-pane label="已通过" name="1"></el-tab-pane>
      </el-tabs>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="company_name" label="充值帐号公司" width="180">
        </el-table-column>
        <el-table-column
          prop="agent_company"
          label="代理商公司名称"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="client_name" label="姓名"> </el-table-column>
        <el-table-column prop="client_phone" label="联系方式">
        </el-table-column>
        <el-table-column prop="aa" label="客户开通地区">
          <template slot-scope="scope">
            <div>
              {{ scope.row.place_data.province_name }} -
              {{ scope.row.place_data.city_name }} -
              {{ scope.row.place_data.district_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="aa" label="营业执照">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.license_img_url"
              :preview-src-list="[scope.row.license_img_url]"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="客户公司行业">
          <template slot-scope="scope">
            <div>
              {{ scope.row.industry_data.first_industry_name }} -
              {{ scope.row.industry_data.second_industry_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="驳回原因"> </el-table-column>
        <el-table-column prop="aa" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button type="warning" @click="editClick(scope.row)"
                >修改</el-button
              >
              <!-- <el-button type="primary" @click="billClick">提交</el-button> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        hide-on-single-page
        background
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { require, url_Api } from "@/utils/http_request.js";
import axios from "axios";
export default {
  name: "recharge_audit",
  //组件引入
  components: {},
  //状态存储
  data() {
    return {
      activeName: "0",
      tableData: [
        {
          company_name: "",
        },
      ],
      total: 0,
      page: 0,
    };
  },
  //计算属性
  computed: {},
  //状态监听
  watch: {},
  //存放方法集合
  methods: {
    handleClick() {},
    toExamineClick() {},
    init() {
      let obj = {
        recharge_status: this.activeName,
        // page: this.page,
      };
      require("POST", "/lufish_sale/v1/recharge_client_list/", obj).then(
        (res) => {
          console.log(res);
          if (!res.code) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          }
        }
      );
    },
  },
  //数据初始化之后
  created() {
    this.init();
  },
  //页面渲染之后
  mounted() {},
  //数据初始化之前
  beforeCreate() {},
  //页面渲染之前
  beforeMount() {},
  //状态更新之前
  beforeUpdate() {},
  //状态更新之后
  updated() {},
  //页面卸载之前
  beforeDestroy() {},
  //卸载之后
  destroyed() {},
  //页面进入   页面缓存时有效
  activated() {},
};
</script>
<style  scoped>
.recharge_audit {
  position: relative;
  width: calc(100% - 209px);
  left: 181px;
  top: 68px;
  padding: 14px;
  min-height: 80vh;
  background: #fff;
}
.caozuo {
  padding: 12px 0px;
  text-align: right;
}
.page {
  text-align: center;
  padding: 12px 0;
}
</style>


// WEBPACK FOOTER //
// src/recharge_management/recharge_audit.vue